<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content point-cloud">
    <div slot="header">
      <window-header cmp-title="3D Viewer" widget-name="pc">
        <template slot="left-options" class="point-cloud-left">
          <b-button :pressed.sync="showPrefs" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="cogs" scale=".7"></icon></b-button>
          <b-button :pressed.sync="showLayers" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="list" scale=".7"></icon></b-button>
          <b-button v-if="[12040,12088].includes(workpack_id)" :pressed.sync="showSeamLayers" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="list-alt" scale=".7"></icon></b-button>
          <!--<div class="align-self-center preload-spinner" v-if="loadingTiles > 0">
            <icon name="spinner" pulse/>
          </div>-->
        </template>
      </window-header>
    </div>
    <div class="flex-full-height" >
      <div id="potree-map">

      </div>
      <div class="compass-d3">
        <svg ref="cmp_d3" class="w-100 h-100"></svg>
      </div>
    </div>
  </b-card>
</template>

<script>
  import 'vue-awesome/icons/link'
  import 'vue-awesome/icons/cut'
  import 'vue-awesome/icons/cogs'
  import 'vue-awesome/icons/list'
  import 'vue-awesome/icons/list-alt'

  import store from '../../store'

  import PotreePlugin from '../../plugin/potree'
  import Vue from 'vue'
  import asyncMap from 'async/map'
  import WindowHeader from '../common/WindowHeader'
  import LoadingOverlay from '../LoadingOverlay'
  import PointCloudSettings from './PointCloudSettings'
  import PointCloudLayers from './PointCloudLayers'
  import PotreeService from '../../service/potreeService'

  import proj4 from 'proj4'
  import * as olProj from 'ol/proj'
  import Projection from 'ol/proj/Projection'

  import { select, event } from 'd3-selection'
  import { lineRadial } from 'd3-shape'

  import {
    EPSG_28356, EPSG_28355
  } from '../../util/projections'
  import SeamLayers from '../SeamLayers'

  proj4.defs('EPSG:28356', EPSG_28356)
  proj4.defs('EPSG:28355', EPSG_28355)

  olProj.addProjection(new Projection({
    code: 'EPSG:28356'
  }))

  export default {
    name: 'potree-viewer',
    components: {WindowHeader, LoadingOverlay},
    created () {
      this.tmpCenter = null
    },
    data () {
      return {
        followMainMap: true,
        clip: false,
        showPrefs: false,
        showLayers: false,
        showSeamLayers: false,
        loading: true
      }
    },
    computed: {
      workpack_id () {
        return this.currentProject.workpack.id
      },
      angle3d () {
        return this.$store.getters['map/angle3d']
      },
      context_coords () {
        return this.$store.getters['map/context_coords']
      },
      screenWidth () {
        return screen.width
      },
      showPotree: {
        get () {
          return this.$store.getters['cmp/all']['pc']['enabled']
        },
        set (val) {
          this.$store.getters['cmp/all']['pc']['enabled'] = val
        }
      },
      layerTree () {
        return store.getters['map/layersTree']
      },
      loadingTiles () {
        return store.getters['map/loadingTiles']
      },
      currentMapCenter () {
        return store.getters['map/currentMapCenter']
      },
      currentProject () {
        return store.getters['project/currentProject']
      }
    },
    watch: {
      angle3d (val) {
        // console.log(val)
        if (isNaN(val)) {
          return
        }
        if (this.compassG) {
          this.compassG
            .attr('transform', `translate(${this.bbox.width / 2}, ${this.bbox.height / 2}) rotate (${-val})`)
        }
      },
      clip (val) {
        if (val) {
          // viewer.volumeTool.startInsertion({clip: true})
          viewer.fitToScreen()
        }
      },
      context_coords (val) {
        let sphereLevel = 1000
        let me = this

        let bsrid = this.$store.getters['project/currentProject'].workpack.best_srid
        me.zoomTocoords(proj4(proj4('EPSG:3857'), proj4(bsrid || 'EPSG:28356')).forward(val), sphereLevel)
        /*this.tranformCoords(val[0], val[1], 3857, bsrid ? parseInt(bsrid.split(':')[1]) : 28356, (c) => {
          me.zoomTocoords(c, sphereLevel)
        })*/

      },
      currentMapCenter (val) {
        let bsrid = this.$store.getters['project/currentProject'].workpack.best_srid
        this.zoomTocoords(proj4(proj4('EPSG:3857'), proj4(bsrid || 'EPSG:28356')).forward(val), 1000)
      },
      layerTree (val) {
        // if (val && this.$potreeService) {
        //   this.syncLayers()
        // }
      },
      showPotree (val) {
        /*if (val && !store.state.map.potreeInitialised) {

        }*/
      },
      showPrefs () {
        let opts = {
          available: true,
          enabled: true,
          clazz: PointCloudSettings,
          w: 4,
          h: 6,
          x: 3,
          y: 0,
          propsData: {
            layer: this.layerItem
          },
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: 'pc_settings',
          payload: opts
        })
      },
      showLayers () {
        let opts = {
          available: true,
          enabled: true,
          clazz: PointCloudLayers,
          w: 3,
          h: 5,
          x: 3,
          y: 0,
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: 'pc_layers',
          payload: opts
        })
      },
      showSeamLayers () {
        let opts = {
          available: true,
          enabled: true,
          clazz: SeamLayers,
          w: 2,
          h: 5,
          x: 3,
          y: 0,
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: 'seam_layers',
          payload: opts
        })
      }
    },
    mounted () {
      setTimeout(() => {
        let opts = this.initMap()
        Vue.prototype.$potreeService = new PotreeService(opts)

        this.setupMap()

      }, 300)
    },
    destroyed () {
      window.viewer = null
      this.$store.commit('map/camera3dPotistion', [0,0].join(','))
    },
    methods: {
      tranformCoords (x, y, fromSrs, toSrs, clb) {
        let me = this

        this.$http.post('/api/layers/transform-coords/', {
          x: x,
          y: y,
          from: fromSrs,
          to: toSrs
        })
          .then(res => {
            console.log(res.body)
            clb.call(me, [res.body.x, res.body.y])
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not transform coords',
              type: 'error'
            })
          })
      },
      syncLayers () {
        // this.$mapService.walkTree(this.layerTree, (layer) => {
        //   if (['wfs', 'wms'].indexOf(layer['data_type']) > -1) {
        //     let exists = this.$map3dService.layerExists(layer)
        //     if (layer['checked'] && !exists) {
        //       this.$map3dService.enableWmsLayer(layer)
        //     }
        //     if (!layer['checked'] && exists) {
        //       this.$map3dService.disableWmsLayer(layer)
        //     }
        //   }
        // })
      },
      getProxyUrl () {
        return location.protocol + '//' + location.host + '/api/greyhound'
        // return 'http://127.0.0.1:8089'
      },
      zoomTocoords (coords, sphereLevel) {
        // GET Current map center for 3D map init
        // let coords = proj4(proj4('EPSG:3857'), proj4('EPSG:28356')).forward(this.$mapService.map.getView().getCenter())
        if (!coords) {
          coords = [270619.609613174, 7016658.09007321]
        }
        if (!sphereLevel) {
          sphereLevel = 6000
        }
        var geometry = new THREE.SphereGeometry( sphereLevel, 32, 32 )
        geometry.translate(coords[0], coords[1], 500)
        var material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
        var sphere = new THREE.Mesh( geometry, material );
        this.$potreeService.viewer.zoomTo(sphere, 1, 0)
      },
      setupMap () {

        this.$potreeService.createBasePlane()
        this.zoomTocoords()
        // this.$potreeService.createLineLayer('centreline', 12007, 0x00FF00, 2)
        // this.$potreeService.createTubeLayer.call(this.$potreeService, 'well_drillstrings', 12007, 0x00FF00, 2)
        // this.$potreeService.createPointLayer('well', 12007, 0x0000FF, 5)

        //render some initial stuff
        if ([12040, 12088].includes(this.currentProject.workpack.id)) {
          this.$potreeService.drawTerrain = false
          this.$potreeService.drawSubsurface = false

          // this.$potreeService.createTestObjects.call(this.$potreeService)
          // this.$potreeService.createCylinderLayer.call(this.$potreeService)
          // this.$potreeService.createLineLayer.call(this.$potreeService, 'roof', 6, 0x00FFFF)
          // this.$potreeService.createSeamsLayer.call(this.$potreeService)
          // this.$potreeService.createTmpLayer.call(this.$potreeService)

          // this.$potreeService.createLineLayer.call(this.$potreeService, 'arms', 6, 0x00e600)
          // this.$potreeService.createPointLayer.call(this.$potreeService, 'topholes', 6, 0xF08080, 6)


          var geometry = new THREE.SphereGeometry( 1000, 32, 32 )
          geometry.translate(610310.000000236, 7649296.00007236, 500)
          var material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
          var sphere = new THREE.Mesh( geometry, material );
          viewer.zoomTo(sphere, 1, 0)

          // this.$potreeService.createLineLayer.call(this.$potreeService, 'well_drillstrings', this.currentProject.workpack.id, 0x00FF00, undefined, 'gl3_r_shp_bowen')



         /* this.$potreeService.vectorLayers.forEach(vl => {
            vl.enabled = true
            this.$potreeService.createLineLayer.call(this.$potreeService, vl.name, vl.workpack_id, vl.color)
          })*/

        } else {
          this.$potreeService.vectorLayers.forEach(vl => {
            vl.enabled = true
            this.$potreeService.createLineLayer.call(this.$potreeService, vl.name, vl.workpack_id, vl.color)
          })

          this.$potreeService.drawTerrain = true
          this.$potreeService.redrawTiles()
        }



      },
      initCompass () {
        let svg = select(this.$refs.cmp_d3)
        let bbox = this.$refs.cmp_d3.getBoundingClientRect()
        this.bbox = bbox


        let g = svg
          .append('g')
          .attr('class', 'compass-g')
          .attr('transform', "translate(" + bbox.width / 2 + "," + bbox.height / 2 + ") ")

        this.compassG = g

        svg.append("svg:defs").append("svg:marker")
          .attr("id", "triangle")
          .attr("refX", 3)
          .attr("refY", 3)
          .attr("markerWidth", 15)
          .attr("markerHeight", 15)
          .attr("orient", "auto")
          .append("path")
          .attr("d", "M 0 0 6 3 0 6 1.5 3")
          .style("fill", "gray");

        /*g.append("path")
          .datum(data)
          .attr("class", "compass-line")
          .attr("d", line);*/

        g.append("circle")
          .attr("class", "compass-circle")
          .attr("r", bbox.width / 2);


        g.append("line")
          .attr("class", "compass-line")
          .attr("y2", (-bbox.height / 2) + 8)
          .attr("marker-end", "url(#triangle)")
      },
      initMap () {
        let viewer = new Potree.Viewer(document.getElementById('potree-map'))

        window.viewer = viewer

        viewer.setEDLEnabled(false)
        // viewer.setEDLRadius(1)
        // viewer.setEDLStrength(2)

        viewer.setFOV(60)
        viewer.setPointBudget(10 * 1000 * 1000)

        viewer.scene.view.yaw = 0
        // UPDATED INITIAL pitch
        // viewer.scene.view.pitch = -Math.PI/2
        viewer.scene.view.pitch = -Math.PI/4
        // let resources = ['quadrants', 'quadrants-da2', 'da8_2', 'da8_3', 'da8_4', 'da8_5', 'da8_6', 'da8_7', 'da8_8']
        if (![12040, 12088].includes(this.currentProject.workpack.id)) {
          let resources = ['quadrants', 'quadrants-da2', 'quadrants-da1', 'quadrants-da72', 'quadrants-da8-1', 'quadrants-da8-2', 'quadrants-da8-3', 'quadrants-da8-5', 'quadrants-da8-6']
          asyncMap(resources, (resource, clb) => {
            Potree.loadPointCloud(`greyhound://${this.getProxyUrl()}/resource/${resource}/`, resource, (e) => {
              if (e.type === 'pointcloud_loaded') {
                console.log(`successfully loaded ${resource}`)
                viewer.scene.addPointCloud(e.pointcloud)
                e.pointcloud.material.size = 1
              } else {
                console.log(`failed to load pointcloud ${resource}`)
                console.error(e)
              }
              clb(null)
            })
          }, (err, res) => {

            // console.log(viewer.scene.getActiveCamera())
            // viewer.fitToScreen(0.5)
            // this.$potreeService.createLineLayer('centreline', 10795, 0x00FF00, 2)
            // this.$potreeService.createPointLayer('well', 10795, 0xFF0000, 5)
            // this.$potreeService.createPolygonLayer('row', 10795, 0x00ccff, 5)
          })
        }

        viewer.setNavigationMode(Potree.EarthControls)
        // window.addEventListener('keydown', function (event) {
        //   if (event.keyCode === 17) {
        //     viewer.setNavigationMode(Potree.OrbitControls)
        //   }
        // }, false)
        //
        // window.addEventListener('keyup', function (event) {
        //   if (event.keyCode === 17) {
        //     viewer.setNavigationMode(Potree.EarthControls)
        //   }
        // }, false)
        console.log(viewer)

        this.initCompass()

        // store.commit('setPotreeInitialised', true)
        return {'viewer': viewer, 'workpackId': this.currentProject.workpack.id, srs: this.currentProject.workpack.best_srid}
      }
    }
  }
</script>

<style lang="scss">

  #potree-map {
    width: 100%;
    height: 100%;
    background-color: lightgray;
    overflow: hidden;
    position: relative;

    .toolbar {
      position: absolute;
      right: 3rem;
      top: 5px;
      z-index: 3;
    }
  }

  .compass-d3 {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    width: 4rem;
    height: 4rem;
  }

  .compass-circle {
    fill: whitesmoke;
    stroke: gray;
    stroke-width: 1.5px;
  }
  .compass-line {
    fill: whitesmoke;
    stroke: gray;
    stroke-width: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/PointCloud.vue